export default {
  data() {
    return {
      fallBackAvatars: {
        male: require("../assets/avatar-male.png"),
        female: require("../assets/avatar-female.png"),
      },
    };
  },
  methods: {
    loadAvatar(person, event) {
      event.target.setAttribute(
        "src",
        person.gender === 1
          ? this.fallBackAvatars.male
          : this.fallBackAvatars.female
      );
    },
  },
};
